export const ONBOARDING_SLUG = {
  INF_SP: 'inf_sp',
  START_SELFIE: 'start_selfie',
  START: 'start',
  ACCOUNT_SETUP: 'account-setup'
} as const

export type OnboardingSlug = typeof ONBOARDING_SLUG[keyof typeof ONBOARDING_SLUG]
